module.exports = __webpack_public_path__ + "static/img/zhongduan.9f12a234.png";